import React from "react";

import { faDownload } from "@fortawesome/pro-solid-svg-icons/faDownload";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

interface Props {
  onClick: () => void;
}

const DownloadSkipFile: React.FC<Props> = ({ onClick }) => {
  const intl = useIntl();
  return (
    <Button onClick={onClick} type="primary">
      {intl.formatMessage(
        {
          id: "settings.newImports.finalizeStep.downloadSkipFile",
          defaultMessage: "Download skip file {icon}",
          description: "Text of Download skip file button",
        },
        {
          icon: <FontAwesomeIcon icon={faDownload} />,
        }
      )}
    </Button>
  );
};

export default DownloadSkipFile;
